export default __webpack_public_path__ + "031f40fbbf7aca3500e8ec1de4553353.png";